import type { AssetDto } from 'src/store/generated/leela-api-generated';

/**
 * Normalizes an asset's campaignIds by including the singular campaignId field
 * when campaignIds is empty. This handles the individual assets collection where
 * each document has campaignId (singular) but campaignIds may be empty.
 */
export function normalizeAssetCampaignIds (asset: AssetDto): AssetDto {
  if (asset.campaignIds && asset.campaignIds.length > 0) {
    return asset;
  }
  if (asset.campaignId) {
    return { ...asset, campaignIds: [asset.campaignId] };
  }
  return asset;
}

/**
 * Normalizes campaignIds for an array of assets.
 */
export function normalizeAssetsCampaignIds (assets: AssetDto[]): AssetDto[] {
  return assets.map(normalizeAssetCampaignIds);
}
